import PropTypes from 'prop-types';
import React, { Component } from 'react';
import helpers from './addJobGradeChartHelpers';
helpers(Component);

import GradeRangeChart from '../../Grades/GradeRangeChart';

export default class AddJobGradeRangeChart extends Component {
  static propTypes = {
    marketRateChart: PropTypes.object,
    marketBase50th: PropTypes.number,
    saveJobGrade: PropTypes.func,
    jobGrade: PropTypes.string,
    recommendGrade: PropTypes.object,
    payStructure: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.id = 'add-job-grade-chart';
    this.duration = 0.3;
  }

  chartLoad(event) {
    const { target: chart } = event;
    const { jobGrade, payStructure, recommendGrade, saveJobGrade } = this.props;
    //do sanity checks.
    const chartContainer = document.querySelector('#add-job-grade-chart');
    if (!chartContainer) return;
    if (!chart.xAxis[0].categories) return;
    this.buildHoverZones(chart, jobGrade, payStructure, recommendGrade, saveJobGrade);
  }

  calculateScatterSeries(chart) {
    let marketBase50th = this.props.marketBase50th;
    const marketRateChart = this.props.marketRateChart;

    if (
      marketRateChart &&
      marketRateChart.highChartsJson &&
      marketRateChart.highChartsJson.gradeSalaryDisplayCode &&
      marketRateChart.highChartsJson.gradeSalaryDisplayCode === 'hourly'
    ) {
      marketBase50th = marketBase50th / 2080;
    }

    const scatterSeriesData = chart.xAxis.categories.map((cat, index) => {
      return {
        x: index,
        y: marketBase50th,
        name: cat
      };
    });

    const newSeries = chart.series.map(series => {
      if (series.id === 'undefined-Market Base Salary 50th (Median)') {
        return { ...series, data: scatterSeriesData };
      }
      return series;
    });

    return newSeries;
  }

  render() {
    let newMarketRateChart;
    const { marketRateChart } = this.props;

    if (marketRateChart && marketRateChart.highChartsJson) {
      const highChartsConfig = { ...marketRateChart.highChartsJson };
      if (highChartsConfig.xAxis.categories) {
        const newSeries = this.calculateScatterSeries(highChartsConfig);
        highChartsConfig.series = newSeries;
      }
      highChartsConfig.chart = {
        ...highChartsConfig.chart,
        events: { load: this.chartLoad.bind(this) }
      };
      highChartsConfig.yAxis = { ...highChartsConfig.yAxis, gridLineWidth: 0 };

      newMarketRateChart = { ...marketRateChart, highChartsJson: highChartsConfig };
    }

    return (
      <GradeRangeChart
        {...this.props}
        id={'add-job-grade-chart'}
        marketRateChart={newMarketRateChart || this.props.marketRateChart}
        removeLoadingText
        jobGrade={this.props.jobGrade}
        recommendGrade={this.props.recommendGrade}
      />
    );
  }
}
